import { language } from "@chef/constants";

export const intl = (
  {
    no: {
      WEEK: "Uke",
      CANCELLED: "Avbestilt",
      CLOSED: "Stengt",
      CAMPAIGN: "kampanje",
      SHORT_DATE_FORMAT: "d. MMM",
      DELIVERED: "Levert",
      IN_TRANSIT: "Underveis",
    },
    se: {
      WEEK: "Vecka",
      CANCELLED: "Avbokad",
      CLOSED: "Stängt",
      CAMPAIGN: "kampanj",
      SHORT_DATE_FORMAT: "d MMM",
      DELIVERED: "Levererad",
      IN_TRANSIT: "På väg",
    },
    dk: {
      WEEK: "Uge",
      CANCELLED: "Afbestilt",
      CLOSED: "Lukket",
      CAMPAIGN: "kampagne",
      SHORT_DATE_FORMAT: "d. MMM",
      DELIVERED: "Leveret",
      IN_TRANSIT: "Undervejs",
    },
  } as const
)[language];
